import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import { createAuth0 } from "@auth0/auth0-vue";

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig();

  const authParams = {
    redirect_uri: window.location.origin,
  };
  const auth0 = createAuth0({
    domain: config.public.AUTH0_DOMAIN,
    clientId: config.public.AUTH0_CLIENT_ID,
    cacheLocation: "localstorage",
    authorizationParams: {
      ...authParams,
    },
  });

  const cookies = document.cookie
    .split(";")
    .reduce((acc: Record<string, string>, cookie) => {
      const [key, value] = cookie.trim().split("=");
      acc[key] = value;
      return acc;
    }, {});
  if (cookies["force-refresh-session"] === "true") {
    const keysToPreserve = ["auth", "token", "logged_in_user_email", "hubspot"];

    Object.keys(localStorage)
      .filter((key) => {
        const lowerKey = key.toLowerCase();
        return !keysToPreserve.some((keyword) => lowerKey.includes(keyword));
      })
      .forEach((key) => localStorage.removeItem(key));

    // Clear the cookie by setting its expiration date to the past
    document.cookie =
      "force-refresh-session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }

  vueApp.use(auth0);

  // Provide the actual Auth0 client instance globally for use outside component setup context
  // After vueApp.use(), the client is available at vueApp.config.globalProperties.$auth0
  const auth0Client = vueApp.config.globalProperties.$auth0;

  return {
    provide: {
      auth0: auth0Client,
    },
  };
});
